import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import { getPatientProfile } from "@/redux/actions/auth";
import type { PatientConsent, ConsentPayloadDTO, ConsentResponseDTO } from "@/core/types";

import { appendPatientConsent } from "../queryFunctions/appendPatientConsent";

type Context = {
  previousConsents: PatientConsent[];
  updatedConsent: PatientConsent;
};

type UseAppendConsentMutationOptions = UseMutationOptions<
  ConsentResponseDTO,
  unknown,
  ConsentPayloadDTO,
  Context
>;

export function useAppendConsent(options?: UseAppendConsentMutationOptions) {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: appendPatientConsent,
    ...options,
    onSuccess: (...args) => {
      /** Refetch profile to redraw the updated view
       * This is a temporary solution until we move profile data to tanstack query
       */
      dispatch(getPatientProfile(true));
      // Execute caller-supplied callback
      options?.onSuccess?.(...args);
    },
  });
}
